import { adaptDataToTable } from './adaptDataToTable';

export { adaptDataToTable };
